var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',_vm._b({staticClass:"pro_badge",attrs:{"color":"pro-bg"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_vm._v("PRO")]},proxy:true}])},'v-badge',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }